import React from 'react';
import { SubjectOption } from '@surveycake/logic-engine';
import Group from '../Group';
import UnselectedItem from './Item';
import { useStyles } from './styles';

export interface UnselectedProps {
  label: string;
  disabled: boolean;
  options: SubjectOption[];
  onSelect: (optionId: number) => void;
}

export default function Unselected({
  label,
  disabled,
  options,
  onSelect
}: UnselectedProps) {
  const styles = useStyles();
  const className = disabled
    ? styles.unselectedItemDisabled
    : styles.unselectedItem;

  return (
    <Group label={label}>
      {options.map(({ ID, text }) => (
        <UnselectedItem
          key={ID}
          id={ID}
          className={className}
          disabled={disabled}
          onSelect={onSelect}
        >
          {text}
        </UnselectedItem>
      ))}
    </Group>
  );
}
